import { defineMessages } from 'react-intl';
export var messages = defineMessages({
    seeAllTopics: { defaultMessage: 'Explore designs' },
    seeAllProducts: { defaultMessage: 'Shop all products' },
    music: { defaultMessage: 'Music' },
    television: { defaultMessage: 'Television' },
    movies: { defaultMessage: 'Movies' },
    animals: { defaultMessage: 'Animals' },
    gaming: { defaultMessage: 'Gaming' },
    sports: { defaultMessage: 'Sports' },
    funny: { defaultMessage: 'Funny' },
    books: { defaultMessage: 'Books' },
    tShirts: { defaultMessage: 'T-Shirts' },
    stickers: { defaultMessage: 'Stickers' },
    wallArt: { defaultMessage: 'Wall Art' },
    blankets: { defaultMessage: 'Blankets' },
    hoodies: { defaultMessage: 'Hoodies' },
    pillows: { defaultMessage: 'Pillows' },
    phoneCases: { defaultMessage: 'Phone Cases' },
});
